import { Fragment } from 'react';
import styled, { withTheme } from 'styled-components';
import I18n from 'I18n';
//@ts-expect-error untyped file
import { getMockThreadHistory } from 'conversations-message-history/thread-history/factories/ThreadHistoryFactory';
//@ts-expect-error untyped file
import { buildSendFromResponders } from 'conversations-internal-schema/widget-data/operators/buildSendFromResponders';
import { WidgetBodyDiv, WidgetBodyDivWrapper } from '../../visitor-widget/components/VisitorWidget';
//@ts-expect-error untyped file
import ChatFeedSimple from './ChatFeedSimple';
import TextInputPreview from './TextInputPreview';
import ThreadListPreview from './ThreadListPreview';
//@ts-expect-error untyped file
import { getChatHeadingConfig } from 'conversations-internal-schema/widget-data/operators/widgetDataGetters';
//@ts-expect-error untyped file
import { chatHeadingRespondersList } from 'conversations-internal-schema/responders/operators/chatHeadingRespondersList';
import { VISITOR } from 'conversations-message-history/common-message-format/constants/legacySenderTypes';
import MessageComposer from '../../message-editor/MessageComposer';
import WidgetFooterStyleWrapper from '../../presentation-components/WidgetFooterStyleWrapper';
import WidgetChatAreaStyleWrapper from '../../presentation-components/WidgetChatAreaStyleWrapper';
//@ts-expect-error untyped file
import WidgetHeader from '../../visitor-widget/components/WidgetHeader';
import VisitorWidgetStyleWrapper from '../../presentation-components/VisitorWidgetStyleWrapper';
import WidgetBranding from '../../visitor-widget/WidgetBranding';
import { KNOWLEDGE_BASE, THREAD_LIST, THREAD_VIEW, CATEGORY_VIEW } from '../../visitor-widget/constants/views';
import { formatOfficeHoursWillReturnTimestamp } from '../../visitor-widget/util/formatOfficeHoursWillReturnTimestamp';
import { useChatWidgetLocale } from '../../visitor-widget/ChatWidgetLocaleContext';
import ThemeProvider from './ThemeProvider';
import { getTrackedSignupUrl } from 'viral-links-lib/viral-tracking/viral-urls';
import { SendButton } from '../../message-editor/SendButton';
import SearchBox from '../../knowledge-base/SearchBox';
import KBNavigation from '../../visitor-widget/components/KBNavigation';
import KBLibraryPreview from './KBLibraryPreview';
import useWidgetData from '../hooks/useWidgetData';
import { KBLibraryProvider } from '../../knowledge-base/context/KBLibraryProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const MAX_POTENTIAL_RESPONDERS = 3;
export const CardsListWrapper = styled.div.withConfig({
  displayName: "ChatWidgetPreview__CardsListWrapper",
  componentId: "s5fekq-0"
})(["height:100%;display:flex;flex-direction:column;"]);
const renderTextInput = () => {
  return /*#__PURE__*/_jsx(TextInputPreview, {});
};
const isBaseKBNavigationView = view => {
  return view === KNOWLEDGE_BASE || view === THREAD_LIST;
};
const ChatWidgetPreview = ({
  availabilityMessageDetails = {},
  inline = false,
  mobile = false,
  navigateToThreadList = () => {},
  size = 'default',
  widgetData,
  previewAwayMessage,
  senders,
  threadHistory,
  widgetView = THREAD_VIEW,
  onPressStartNewChatButton = () => {},
  onClose,
  showBackButton,
  widgetSize,
  updateView = () => {},
  showingHsBranding,
  isKBSetupPage = false,
  isUngatedForCustomerAgentPrompts = false
}) => {
  const {
    chatHeadingConfig,
    initialMessage,
    knowledgeBaseEnabled,
    knowledgeBaseRecommendationType,
    knowledgeBaseId,
    knowledgeBaseUrl,
    isKnowledgeBaseV3,
    coloring,
    sendFrom,
    firstMessage,
    sendFromResponders,
    responder,
    enableSdkCloseButton
  } = useWidgetData(widgetData, previewAwayMessage);
  const locale = useChatWidgetLocale();
  // Treat "inline" as the boolean for whether we're in a mobile chatflow as "mobile"
  // is not used for this preview in Chatflows (but *is* used in HD/Inbox settings)
  const previewCloseButtonClickHandler = inline && enableSdkCloseButton || !inline && isUngatedForCustomerAgentPrompts ? () => {} : undefined;
  const renderThreadList = () => /*#__PURE__*/_jsx(ThreadListPreview, {
    coloring: coloring,
    initialMessage: initialMessage,
    chatHeadingConfig: chatHeadingConfig,
    responder: responder,
    onPressStartNewChatButton: onPressStartNewChatButton,
    widgetView: widgetView
  });
  const renderKBInWidgetBody = () => {
    if (widgetView === THREAD_LIST) {
      return renderThreadList();
    }
    return /*#__PURE__*/_jsxs(CardsListWrapper, {
      children: [widgetView === KNOWLEDGE_BASE && /*#__PURE__*/_jsx(SearchBox, {
        disabled: true,
        isOnSearchMode: false,
        searchTerm: '',
        setSearchTerm: () => {},
        updateSearchMode: () => {}
      }), /*#__PURE__*/_jsx(KBLibraryPreview, {
        kbRecommendationType: knowledgeBaseRecommendationType,
        knowledgeBaseUrl: knowledgeBaseUrl,
        knowledgeBaseId: knowledgeBaseId,
        coloring: coloring,
        knowledgeBaseEnabled: knowledgeBaseEnabled,
        isKnowledgeBaseV3: isKnowledgeBaseV3,
        updateView: updateView,
        currentView: widgetView
      })]
    });
  };
  const renderChatBody = () => {
    if (widgetView === THREAD_LIST) {
      return renderThreadList();
    }
    const mockThreadHistory = getMockThreadHistory({
      firstMessage,
      includeVisitorReply: false,
      officeHoursMessageText: '',
      replyTimeMessageText: '',
      emailCapturePromptMessageText: ''
    });
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(ChatFeedSimple, {
        chatHeadingConfig: getChatHeadingConfig(widgetData),
        sendFromResponders: sendFromResponders.take(MAX_POTENTIAL_RESPONDERS),
        coloring: coloring,
        currentRole: VISITOR,
        potentialResponders: buildSendFromResponders(widgetData),
        senders: senders,
        threadHistory: threadHistory || mockThreadHistory,
        mobile: mobile
      }), /*#__PURE__*/_jsx(WidgetFooterStyleWrapper, {
        mobile: mobile,
        children: /*#__PURE__*/_jsx(MessageComposer, {
          inputToRender: renderTextInput(),
          disabled: false,
          children: /*#__PURE__*/_jsx(SendButton, {
            disabled: true
          })
        })
      })]
    });
  };
  const renderWidgetBody = () => {
    if (widgetView !== THREAD_VIEW && (isKBSetupPage || knowledgeBaseEnabled)) {
      return renderKBInWidgetBody();
    }
    return renderChatBody();
  };
  const chatHeaderRespondersList = chatHeadingRespondersList({
    chatHeadingConfig,
    responders: sendFrom
  });
  const {
    showAvailabilityMessage,
    officeHoursAvailabilityTimestamp,
    previewResponseTimeText
  } = availabilityMessageDetails;
  const getHeaderText = () => {
    if (widgetView === THREAD_LIST) {
      return I18n.text('conversations-visitor-experience-components.knowledgeBase.threadListHeaderText', {
        locale
      });
    }
    if (widgetView === KNOWLEDGE_BASE) {
      return I18n.text('conversations-visitor-experience-components.knowledgeBase.kbHeaderText', {
        locale
      });
    }
    return null;
  };
  const kbNavigationEnabled = isBaseKBNavigationView(widgetView) && (isKBSetupPage || knowledgeBaseEnabled);
  return /*#__PURE__*/_jsx(ThemeProvider, {
    coloring: coloring,
    children: /*#__PURE__*/_jsxs(VisitorWidgetStyleWrapper, {
      browserWindowHeight: 1080,
      mobile: mobile,
      inline: inline,
      size: size,
      widgetSize: widgetSize,
      children: [/*#__PURE__*/_jsx(KBLibraryProvider, {
        children: ({
          originView,
          selectedCategory,
          selectedArticle
        }) => {
          return /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(WidgetHeader, {
              chatHeadingConfig: chatHeadingConfig,
              coloring: coloring,
              chatHeadingResponders: chatHeaderRespondersList,
              mobile: mobile,
              navigateToThreadList: () => navigateToThreadList(widgetView),
              onClose: onClose,
              preview: true,
              showAvailabilityMessage: showAvailabilityMessage,
              previewResponseTimeText: officeHoursAvailabilityTimestamp ? formatOfficeHoursWillReturnTimestamp(officeHoursAvailabilityTimestamp, locale) : previewResponseTimeText,
              view: widgetView,
              showBackButton: showBackButton,
              customHeaderText: widgetView === CATEGORY_VIEW ? selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.categoryName : getHeaderText(),
              sdkCloseButtonClickHandler: previewCloseButtonClickHandler,
              restorePreviousViewFromKBArticle: () => {
                updateView(originView);
              },
              kbArticleDeepLink: selectedArticle === null || selectedArticle === void 0 ? void 0 : selectedArticle.deepLink
            }), /*#__PURE__*/_jsx(WidgetBodyDivWrapper, {
              $background: coloring === null || coloring === void 0 ? void 0 : coloring.accentColor,
              kbNavigationEnabled: kbNavigationEnabled,
              isOnSearchMode: false,
              children: /*#__PURE__*/_jsx(WidgetBodyDiv, {
                children: /*#__PURE__*/_jsxs(WidgetChatAreaStyleWrapper, {
                  children: [renderWidgetBody(), showingHsBranding && /*#__PURE__*/_jsx(WidgetBranding
                  //@ts-expect-error existing viral link
                  , {
                    liveChatHref: getTrackedSignupUrl({}),
                    lang: locale
                  })]
                })
              })
            })]
          });
        }
      }), kbNavigationEnabled && /*#__PURE__*/_jsx(KBNavigation, {
        coloring: coloring,
        updateView: updateView,
        view: widgetView
      })]
    })
  });
};
ChatWidgetPreview.displayName = 'ChatWidgetPreview';
export default withTheme(ChatWidgetPreview);